import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { get } from 'lodash'
import { AdditionalInfoPhoneAgent } from 'src/constants/trackingEvents'
import QuestionSingle from './QuestionSingleContainer'
import mockAgent from './mockAgent'
import { FormattedMessage } from 'react-intl'
import { Avatar, If, Unless, Text } from 'src/Components'
import { Player } from 'src/Components/shared/Player'
import { SponsorBranding } from 'src/Components/shared/SponsorBranding'
import Phone from 'src/Components/shared/Phone'
import NMLS from 'src/Components/shared/NMLS'

import styles from './Questions.module.scss'

const propTypes = {
  testDrive: PropTypes.bool,
  questions: PropTypes.array,
  questionTopic: PropTypes.string,
  customerProfile: PropTypes.object,
  sponsor: PropTypes.object,
  customerFirstName: PropTypes.string,
  sponsorshipFullName: PropTypes.string,
  sponsorshipFirstName: PropTypes.string,
  sponsorshipLastName: PropTypes.string,
  renderHeader: PropTypes.func,
  moveMobileAvatarAbove: PropTypes.bool,
  location: PropTypes.string,
  isBuyer: PropTypes.bool,
  disableCospo: PropTypes.bool,
  renderSponsorBranding: PropTypes.bool,
  sponsorVideoId: PropTypes.string,
  sponsorVideoType: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

class Questions extends PureComponent {
  static propTypes = propTypes

  isCoSpo () {
    const { customerProfile } = this.props
    const agent = this.getRenderedAgent()

    return agent !== customerProfile
  }

  getRenderedAgent () {
    const { customerProfile, isBuyer, sponsor, testDrive } = this.props

    if (sponsor && sponsor.id) {
      return sponsor
    }

    if (isBuyer && testDrive && customerProfile.type === 'real-estate-agents') {
      return mockAgent
    }

    return customerProfile
  }

  renderCoSpoMessage () {
    const {
      customerFirstName,
      sponsorshipFirstName,
      sponsorshipFullName,
      sponsorVideoId,
      sponsorVideoType,
      renderSponsorBranding
    } = this.props

    return (
      <>
        <If condition={renderSponsorBranding}>
          <SponsorBranding className={styles.sponsorBranding} />
        </If>
        <Unless condition={renderSponsorBranding}>
          <Text color='quiet' size='s'>
            <FormattedMessage
              id='Questions.cospoMessage'
              defaultMessage="{customerName} recommends {cospoName}, a lender that is happy to help answer questions for {customerName}'s clients and show how scenarios can save money."
              values={{
                customerName: customerFirstName,
                cospoName: (
                  <Text element='span' color='white'>
                    {sponsorshipFullName}
                  </Text>
                )
              }}
            />
          </Text>
        </Unless>
        <If condition={sponsorVideoId && sponsorVideoType}>
          <Player
            className={styles.sponsorVideo}
            videoId={sponsorVideoId}
            videoType={sponsorVideoType}
          />
        </If>
        <h3>
          <FormattedMessage
            id='RefiDetailsModal.questions.ask'
            defaultMessage='Any questions for {name}?'
            values={{ name: sponsorshipFirstName }}
          />
        </h3>
      </>
    )
  }

  renderAgent () {
    const agent = this.getRenderedAgent()
    const phone = get(agent, 'mobilePhone', agent.workPhone)

    return (
      <div className={styles.agentContainer} data-qa='contactInfo'>
        <Avatar className={styles.avatar} src={agent.photoUri || agent.photo} />
        <div className={styles.agentContact}>
          <p className={styles.lead}>
            {agent.firstName} {agent.lastName}
          </p>
          <p>
            <Phone
              value={phone}
              track={AdditionalInfoPhoneAgent}
              trackOptions={{
                eventLabel: this.props.location,
                eventValue: this.isCoSpo() ? 'sponsor' : 'agent'
              }}
            />
          </p>
          <NMLS element='p' value={agent.nmls} />
        </div>
      </div>
    )
  }

  render () {
    const {
      children,
      disableCospo,
      questions,
      questionTopic,
      renderHeader,
      moveMobileAvatarAbove
    } = this.props

    const renderSponsorContent = this.isCoSpo() && !disableCospo

    return (
      <div
        className={classnames(
          styles.container,
          moveMobileAvatarAbove && styles.moveMobileAvatarAbove
        )}
      >
        {typeof renderHeader === 'function' ? (
          <div className={styles.headline}>{renderHeader()}</div>
        ) : (
          <h3 className={styles.headline}>
            <FormattedMessage
              id='Questions.headline'
              defaultMessage='Want to learn more?'
            />
          </h3>
        )}
        <If condition={renderSponsorContent}>{this.renderCoSpoMessage()}</If>
        <If condition={children}>{children}</If>
        <div className={styles.messageContainer} data-qa='dm-message-container'>
          <div className={styles.column}>
            <div className={styles.questions}>
              {questions.map(({ question, placeholder }, i) => (
                <QuestionSingle
                  key={i}
                  name={`input_${i}`}
                  question={question}
                  placeholder={placeholder}
                  questionTopic={questionTopic}
                  disableCospo={disableCospo}
                />
              ))}
            </div>
          </div>

          <div className={styles.contactColumn}>{this.renderAgent()}</div>
        </div>
      </div>
    )
  }
}

export default Questions
